import { Box, Container, Paper, Typography } from "@mui/material";
import { TERMS_OF_USE_TEXT } from "../utils/termsOfUseText";

function TermosDeUso() {
  return (
    <Container maxWidth="md" sx={{ py: { xs: 3, sm: 4, md: 5 }, px: { xs: 2, sm: 3, md: 4 } }}>
      <Paper
        elevation={0}
        sx={{ p: { xs: 2, sm: 3, md: 4 }, borderRadius: 2, bgcolor: "background.paper" }}
      >
        <Typography
          variant="h4"
          component="h1"
          sx={{
            mb: { xs: 2, md: 3 },
            fontWeight: 700,
            fontSize: { xs: "1.2rem", sm: "1.5rem", md: "2.125rem" },
          }}
        >
          Termos de Uso
        </Typography>

        <Box
          sx={{
            whiteSpace: "pre-line",
            lineHeight: 1.8,
            color: "text.primary",
            fontSize: { xs: "0.875rem", sm: "0.95rem", md: "0.98rem" },
          }}
        >
          {TERMS_OF_USE_TEXT}
        </Box>
      </Paper>
    </Container>
  );
}

export default TermosDeUso;